export function common() {
  let headerPosition = 100;

  const targetElement = document.getElementById("js-headerHeight");
  
  // スクロールに合わせて要素を移動（表示域から隠す）
  window.addEventListener("scroll", () => {
    // スクロール位置を保持
    let scrollPosition = document.documentElement.scrollTop;

    if (headerPosition <= scrollPosition) {
      targetElement.classList.add('is-height');
    } else if (headerPosition > scrollPosition) {
      targetElement.classList.remove('is-height');
    }
  });

  const nav = document.getElementById("js-nav");
  const menuBtn = document.getElementById("js-menu_btn");

  const menuShow = () => {
    menuBtn.addEventListener("click", () => {
      menuBtn.classList.toggle("is-active");
      nav.classList.toggle("is-active");
    });
  };

  menuShow();
}